import type { CreateLiteralItemsConfig } from './types.js';

export const createLiteral: CreateLiteralItemsConfig = config => {
  return config;
};
